import { __assign, __extends } from "tslib";
import React, { Component } from "react";
import { PnmacSectionListView, PnmacPageBubble, PnmacRowHeader, PnmacRowItem, PnmacCard, PnmacParagraph, PnmacMediaQuery, PnmacMeta } from 'pnmac-universal-components';
import { connect } from "react-redux";
import * as Actions from "../redux/actions/actions.js";
import { bindActionCreators } from "redux";
import styles from '../styles/styles.js';
import moment from 'moment';
import { currencyFormatter, percentFormatter, getActiveFeatures } from '../utils.js';
import Tooltip from '@material-ui/core/Tooltip';
import BannerView from "../v2/BannerView";
import { textStyle } from "../v2/theme";
var PmiDeletionAction = function (_a) {
  var translations = _a.translations,
    layout = _a.layout,
    callback = _a.callback;
  var loanNumber = layout === null || layout === void 0 ? void 0 : layout.selectedLoanNumber;
  React.useEffect(function () {
    fetch("/api/loan/get_pmi_deletion", {
      method: 'POST',
      headers: {
        "Content-Type": "application/json; charset=utf-8",
        "Authorization": "Bearer ".concat(layout.token)
      },
      body: JSON.stringify({
        loanId: layout === null || layout === void 0 ? void 0 : layout.selectedLoanNumber
      })
    }).then(function (res) {
      return res.json();
    }).then(function (data) {
      if (data && data.lafaCode != null) {
        callback({
          canSeeBannerStatus: data.lafaCode
        });
      }
    });
  }, [loanNumber]);
  return /*#__PURE__*/React.createElement(PnmacMeta, {
    tittle: translations.MortgageInsuranceTitle
  });
};
var PnmacToolTip = function (_a) {
  var title = _a.title,
    children = _a.children;
  return /*#__PURE__*/React.createElement(Tooltip, {
    title: title
  }, children);
};
var map = {
  0: "Unknown",
  1: "Primary Residence",
  2: "Second Home",
  3: "Investment"
};
var MortgageInsurance = /** @class */function (_super) {
  __extends(MortgageInsurance, _super);
  function MortgageInsurance(props) {
    var _this = _super.call(this, props) || this;
    _this.expRef = /*#__PURE__*/React.createRef();
    _this.request = true;
    _this.state = {
      canSeeBannerStatus: null
    };
    return _this;
  }
  MortgageInsurance.prototype.componentDidMount = function () {};
  MortgageInsurance.prototype.render = function () {
    var _this = this;
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
    var _p = this.props,
      translations = _p.translations,
      layout = _p.layout;
    var canSeeBannerStatus = this.state.canSeeBannerStatus;
    var DATAEXPANDABLE = [{
      title: "".concat(translations === null || translations === void 0 ? void 0 : translations.PrivateMortgageInfo, " ").concat(translations.AsOf, " ").concat(moment().format("MMMM DD, yyyy")),
      data: [{
        label: translations.LoanType,
        header: "".concat(translations === null || translations === void 0 ? void 0 : translations.PrivateMortgageInfo, " ").concat(translations.AsOf, " ").concat(moment().format("MMMM DD, yyyy")),
        value: ((_a = layout === null || layout === void 0 ? void 0 : layout.currentLoan) === null || _a === void 0 ? void 0 : _a.mortgageTypeDescription) || translations.NotAvailable
      }, {
        label: translations.LoanNumber,
        header: "".concat(translations === null || translations === void 0 ? void 0 : translations.PrivateMortgageInfo, " ").concat(translations.AsOf, " ").concat(moment().format("MMMM DD, yyyy")),
        value: (_b = layout === null || layout === void 0 ? void 0 : layout.currentLoan) === null || _b === void 0 ? void 0 : _b.loanId
      }, {
        label: "".concat(translations.MortgageInsurance, " ").concat(translations.PremiumAmount),
        header: "".concat(translations === null || translations === void 0 ? void 0 : translations.PrivateMortgageInfo, " ").concat(translations.AsOf, " ").concat(moment().format("MMMM DD, yyyy")),
        value: currencyFormatter('en-US', 'currency', 'USD', (_c = layout === null || layout === void 0 ? void 0 : layout.currentLoan) === null || _c === void 0 ? void 0 : _c.mortgageInsuranceMonthlyPaymentAmount)
      }, {
        label: translations.NextDisbursementDate,
        header: "".concat(translations === null || translations === void 0 ? void 0 : translations.PrivateMortgageInfo, " ").concat(translations.AsOf, " ").concat(moment().format("MMMM DD, yyyy")),
        value: ((_d = layout === null || layout === void 0 ? void 0 : layout.currentLoan) === null || _d === void 0 ? void 0 : _d.mortgageInsuranceNextPremiumDueDate) ? moment((_e = layout === null || layout === void 0 ? void 0 : layout.currentLoan) === null || _e === void 0 ? void 0 : _e.mortgageInsuranceNextPremiumDueDate).format("MM/DD/YYYY") : translations.NotAvailable
      }, {
        label: translations.CurrentLTV,
        header: "".concat(translations === null || translations === void 0 ? void 0 : translations.PrivateMortgageInfo, " ").concat(translations.AsOf, " ").concat(moment().format("MMMM DD, yyyy")),
        value: getActiveFeatures(layout.features, "PMIRatio_Enabled", layout.whitelisted) ? isNaN(parseInt((_f = layout === null || layout === void 0 ? void 0 : layout.currentLoan) === null || _f === void 0 ? void 0 : _f.pmiRatio)) ? "0%" : "".concat(parseInt((_g = layout === null || layout === void 0 ? void 0 : layout.currentLoan) === null || _g === void 0 ? void 0 : _g.pmiRatio), "%") : isNaN(parseFloat((_h = layout === null || layout === void 0 ? void 0 : layout.currentLoan) === null || _h === void 0 ? void 0 : _h.loanToValueRatioPercent)) ? "0.00%" : "".concat(percentFormatter('en-US', 'decimal', parseFloat((_j = layout === null || layout === void 0 ? void 0 : layout.currentLoan) === null || _j === void 0 ? void 0 : _j.loanToValueRatioPercent) * 100, 2), "%")
      }, {
        label: translations.PropertyType,
        header: "".concat(translations === null || translations === void 0 ? void 0 : translations.PrivateMortgageInfo, " ").concat(translations.AsOf, " ").concat(moment().format("MMMM DD, yyyy")),
        value: map[((_k = layout === null || layout === void 0 ? void 0 : layout.currentLoan) === null || _k === void 0 ? void 0 : _k.propertyUsageType) || 0]
      }, {
        label: translations.Units,
        header: "".concat(translations === null || translations === void 0 ? void 0 : translations.PrivateMortgageInfo, " ").concat(translations.AsOf, " ").concat(moment().format("MMMM DD, yyyy")),
        value: (_l = layout === null || layout === void 0 ? void 0 : layout.currentLoan) === null || _l === void 0 ? void 0 : _l.propertyFinancedNumberOfUnits
      }, {
        label: translations.OriginationDate,
        header: "".concat(translations === null || translations === void 0 ? void 0 : translations.PrivateMortgageInfo, " ").concat(translations.AsOf, " ").concat(moment().format("MMMM DD, yyyy")),
        value: ((_m = layout === null || layout === void 0 ? void 0 : layout.currentLoan) === null || _m === void 0 ? void 0 : _m.noteDate) ? moment((_o = layout === null || layout === void 0 ? void 0 : layout.currentLoan) === null || _o === void 0 ? void 0 : _o.noteDate).format("MM/DD/YYYY") : translations.NotAvailable
      }]
    }];
    return /*#__PURE__*/React.createElement(PnmacMediaQuery, {
      queries: {
        small: "(max-width: 599px)",
        medium: "(min-width: 600px) and (max-width: 1199px)",
        large: "(min-width: 1200px)"
      }
    }, function (matches) {
      var _a;
      return /*#__PURE__*/React.createElement("div", {
        style: {
          paddingLeft: matches.large ? 10 : 0,
          paddingRight: 0
        }
      }, /*#__PURE__*/React.createElement(PmiDeletionAction, {
        translations: translations,
        callback: function (data) {
          return _this.setState(data);
        },
        layout: layout
      }), /*#__PURE__*/React.createElement(PnmacPageBubble, {
        accessibilityRole: "header",
        ariaLevel: "1",
        text: translations.MortgageInsuranceTitle,
        containerStyles: {
          marginLeft: 10,
          marginBottom: 10
        }
      }), canSeeBannerStatus != null ? /*#__PURE__*/React.createElement(BannerView, null, /*#__PURE__*/React.createElement(PnmacParagraph, {
        style: textStyle.notificationText
      }, /*#__PURE__*/React.createElement("span", {
        className: 'htmlToNative',
        dangerouslySetInnerHTML: {
          __html: (_a = translations["BannerStatus".concat(canSeeBannerStatus)]) === null || _a === void 0 ? void 0 : _a.replace("${FAQ}", "<a href='/Home/FAQ'>".concat(translations === null || translations === void 0 ? void 0 : translations.FAQ, "</a>")).replace("${RequestId}", "").replace("${RequestedOn}", "".concat(moment().format("MM/DD/YYYY"))).replace("${AmortCalc}", "<a href='/AmortizationCalculator'>".concat(translations === null || translations === void 0 ? void 0 : translations.AmortizationCalculator, "</a>")).replace("${SecureMessage}", "<a href='/MessageCenter'>".concat(translations === null || translations === void 0 ? void 0 : translations.SecureMessage, "</a>"))
        }
      }))) : null, /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: 10
        }
      }, /*#__PURE__*/React.createElement(PnmacSectionListView, {
        openDefaults: DATAEXPANDABLE.map(function (d) {
          return d.title;
        }),
        ref: _this.expRef,
        data: DATAEXPANDABLE,
        collapsableSections: true,
        renderItem: function (_a, collapsed) {
          var _b, _c;
          var index = _a.index,
            item = _a.item;
          if (collapsed.some(function (s) {
            return s == item.header;
          })) {
            var notLastElement_1 = index <= ((_c = (_b = DATAEXPANDABLE.find(function (title) {
              return title.title == item.header;
            })) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.length) - 2;
            return /*#__PURE__*/React.createElement(PnmacRowItem, {
              rowContainerStyles: __assign({
                marginTop: 0,
                marginBottom: 0
              }, textStyle.formLineWeight),
              renderChildren: function () {
                var _a, _b, _c;
                return /*#__PURE__*/React.createElement("div", {
                  style: __assign(__assign({}, (_a = styles.selectionListView) === null || _a === void 0 ? void 0 : _a.rowItemStyles), {
                    borderBottomLeftRadius: notLastElement_1 ? 0 : 10,
                    borderBottomRightRadius: notLastElement_1 ? 0 : 10,
                    boxShadow: notLastElement_1 ? "none" : "rgba(0, 0, 0, 0.08) 2px 4px 12px"
                  })
                }, /*#__PURE__*/React.createElement("div", {
                  style: (_b = styles.selectionListView) === null || _b === void 0 ? void 0 : _b.fiftyWidth
                }, /*#__PURE__*/React.createElement("div", {
                  style: textStyle.formBody
                }, /*#__PURE__*/React.createElement("b", null, item.label))), /*#__PURE__*/React.createElement("div", {
                  style: __assign(__assign({}, (_c = styles.selectionListView) === null || _c === void 0 ? void 0 : _c.fiftyWidth), {
                    marginRight: 10
                  })
                }, /*#__PURE__*/React.createElement("div", {
                  style: textStyle.formBody
                }, item.value)));
              }
            });
          } else {
            return null;
          }
        },
        renderSectionHeader: function (_a) {
          var _b, _c, _d, _e;
          var title = _a.section.title;
          var open = ((_c = (_b = _this.expRef) === null || _b === void 0 ? void 0 : _b.current) === null || _c === void 0 ? void 0 : _c.state.collapsed.indexOf(title)) > -1;
          return /*#__PURE__*/React.createElement(PnmacRowHeader, {
            rowHeaderStyles: styles.selectionListView.rowHeaderStyles,
            rowHeaderContainerStyles: {
              borderBottom: open ? "1px solid #e9e9e9" : "none",
              borderBottomLeftRadius: open ? 0 : 10,
              borderBottomRightRadius: open ? 0 : 10
            },
            onClickExpand: function () {
              var _a;
              return (_a = _this.expRef) === null || _a === void 0 ? void 0 : _a.current.collapseItem(title);
            },
            item: /*#__PURE__*/React.createElement(PnmacToolTip, {
              title: "Expand " + title
            }, /*#__PURE__*/React.createElement("div", {
              style: textStyle.formTitleSection
            }, title)),
            isExpand: ((_e = (_d = _this.expRef) === null || _d === void 0 ? void 0 : _d.current) === null || _e === void 0 ? void 0 : _e.state.collapsed.indexOf(title)) > -1
          });
        }
      })));
    });
  };
  return MortgageInsurance;
}(Component);
var mapStateToProps = function (state) {
  return {
    layout: state,
    translations: state.translations
  };
};
var mapDispatchToProps = function (dispatch) {
  return __assign({
    dispatch: dispatch
  }, bindActionCreators(Actions, dispatch));
};
export default connect(mapStateToProps, mapDispatchToProps)(MortgageInsurance);